





import {
  Component,
  Vue,
  Emit,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import { IDateRangeUpdate } from "../models/interfaces/date-range-update.model.interface";
import moment from "moment";
import { DatePicker } from "element-ui";

const UserSelectionModule = namespace("userSelectionModule");
const dateFormat = "DD/MM/YYYY HH:mm";

@Component({
  components: {
    "date-picker": DatePicker
  }
})
export default class DatePickerVue extends Vue {
  @UserSelectionModule.Getter public selectedDates;
  @UserSelectionModule.Action public updateDate;

  get defaultStartDate(): Date {
    return this.selectedDates[0];
  }

  get defaultEndDate(): Date {
    return this.selectedDates[1];
  }

  @Provide() public pickedDates: Date[] = [];

  @Provide() public start: string = "";

  @Provide() public end: string = "";

  @Provide()
  public options = {
    disabledDate(time) {
      return time.getTime() > Date.now();
    },
    shortcuts: [
      {
        text: "Last 30 days",
         onClick(picker: DatePicker) {
          const end = moment().endOf("day"); // from the start of the current year to the date today
          const start = moment().subtract(30, "day").startOf("day");
          picker.$emit("pick", [start.toDate(), end.toDate()]);
        }
      },
      {
        text: "Today",
         onClick(picker: DatePicker) {
          const end = moment().endOf("day");
          const start = moment().startOf("day");
          picker.$emit("pick", [start.toDate(), end.toDate()]);
        }
      },
      {
        text: "Yesterday",
         onClick(picker: DatePicker) {
          const end = moment().subtract(1, "day").endOf("day");
          const start = moment().subtract(1, "day").startOf("day");
          picker.$emit("pick", [start.toDate(), end.toDate()]);
        }
      },
      {
        text: "Last 7 days",
         onClick(picker: DatePicker) {
          const end = moment().endOf("day");
          const start = moment().subtract(7, "day").startOf("day");
          picker.$emit("pick", [start.toDate(), end.toDate()]);
        }
      },
      {
        text: "Current month",
        onClick(picker: DatePicker) {
          const end = moment().endOf("day");
          const start = moment().startOf("month").startOf("day");
          picker.$emit("pick", [start.toDate(), end.toDate()]);
        }
      },
      {
        text: "Last Month",
         onClick(picker: DatePicker) {
          const end = moment().subtract(1, "month").endOf("month");
          const start = moment().subtract(1, "month").startOf("month").startOf("day");
          picker.$emit("pick", [start.toDate(), end.toDate()]);
        }
      },
      {
        text: "Current Quarter",
        onClick(picker: DatePicker) {
          const end = moment().endOf("day");
          const start = moment().startOf("quarter").startOf("day");
          picker.$emit("pick", [start.toDate(), end.toDate()]);
        }
      },
      {
        text: "Last Quarter",
        onClick(picker: DatePicker) {
          const end = moment().subtract(1, "quarter").endOf("quarter");
          const start = moment().subtract(1, "quarter").startOf("quarter").startOf("day");
          picker.$emit("pick", [start.toDate(), end.toDate()]);
        }
      },
      {
        text: "Current Year",
        onClick(picker: DatePicker) {
          const end = moment().endOf("day");
          const start = moment().dayOfYear(1).startOf("day");
          picker.$emit("pick", [start.toDate(), end.toDate()]);
        }
      },
        {
        text: "Last Year",
        onClick(picker: DatePicker) {
          const end = moment().subtract(1, "year").endOf("year");
          const start = moment().subtract(1, "year").dayOfYear(1).startOf("day");
          picker.$emit("pick", [start.toDate(), end.toDate()]);
        }
      }
    ]
  };

  @Watch("pickedDates")
  public onDatesChanged() {
    if (this.pickedDates !== null) {
      const model: IDateRangeUpdate = {
        dateFrom: this.pickedDates[0],
        dateTo: this.pickedDates[1]
      };

      this.updateDate(model);
    }
  }

  public mounted() {
    if (this.selectedDates) {
      this.pickedDates = this.selectedDates;
      moment(this.defaultStartDate).format(dateFormat);
      moment(this.defaultEndDate).format(dateFormat);
    }
  }
}
